import { BotIcon } from "lucide-react";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { TooltipIconButton } from "@/components/assistant-ui/tooltip-icon-button";

interface AIBubbleButtonProps {
  onClick: () => void;
}

export const AIBubbleButton: FC<AIBubbleButtonProps> = ({ onClick }) => {
  const { t } = useTranslation("ai-chat");

  return (
    <div className="fixed right-4 bottom-4 z-40">
      <TooltipIconButton
        variant="default"
        tooltip={t("bubble.openAssistant")}
        side="left"
        onClick={onClick}
        className="h-14 w-14 rounded-full shadow-lg transition-all hover:scale-110 active:scale-95 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 hover:shadow-xl hover:shadow-purple-500/50"
      >
        <BotIcon className="w-7 h-7 text-white" />
      </TooltipIconButton>
    </div>
  );
};
